import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import join from 'lodash/join'

import Message from './Message'

import styles from './styles.module.scss'

const TypingIndicator = ({names}) => {
  return (
    <Message
      messageNode={
        <>
          <div
            className={classNames(
              styles.typingIndicator,
              styles.typingIndicator1
            )}
          />
          <div
            className={classNames(
              styles.typingIndicator,
              styles.typingIndicator2
            )}
          />
          <div
            className={classNames(
              styles.typingIndicator,
              styles.typingIndicator3
            )}
          />
        </>
      }
      from={join(names, ',')}
    />
  )
}

TypingIndicator.propTypes = {
  names: PropTypes.arrayOf(PropTypes.string),
}

export default TypingIndicator
